// AUTO-GENERATED SQL Builder (V40 Final) for BookingChangeProposal
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class BookingChangeProposalSql {
  private ast = new SqlAst('BookingChangeProposal', 'bookingChangeProposal');
  public readonly main: any = {};

  public guid: SqlField;
  public bookingId: SqlField;
  public proposedBy: SqlField;
  public proposedDate: SqlField;
  public eventDate: SqlField;
  public eventTime: SqlField;
  public eventSessionId: SqlField;
  public guests: SqlField;
  public venueAddress: SqlField;
  public primaryOfferingId: SqlField;
  public totalAmount: SqlField;
  public depositAmount: SqlField;
  public note: SqlField;
  public packagesJson: SqlField;
  public adjustmentsJson: SqlField;
  public status: SqlField;
  public decidedDate: SqlField;
  public depositPercent: SqlField;
  public booking: SqlNavHybrid;
  public createdByUser: SqlNavHybrid;
  public eventSession: SqlNavHybrid;
  public primaryOffering: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('bookingChangeProposal', 'guid', '', 'id', 'bookingChangeProposal_guid');
    this.bookingId = new SqlField('bookingChangeProposal', 'bookingId', 'booking', 'id', 'bookingChangeProposal_booking');
    this.proposedBy = new SqlField('bookingChangeProposal', 'proposedBy', '', 'id', 'bookingChangeProposal_proposedBy');
    this.proposedDate = new SqlField('bookingChangeProposal', 'proposedDate', '', 'id', 'bookingChangeProposal_proposedDate');
    this.eventDate = new SqlField('bookingChangeProposal', 'eventDate', '', 'id', 'bookingChangeProposal_eventDate');
    this.eventTime = new SqlField('bookingChangeProposal', 'eventTime', '', 'id', 'bookingChangeProposal_eventTime');
    this.eventSessionId = new SqlField('bookingChangeProposal', 'eventSessionId', 'eventSession', 'id', 'bookingChangeProposal_eventSession');
    this.guests = new SqlField('bookingChangeProposal', 'guests', '', 'id', 'bookingChangeProposal_guests');
    this.venueAddress = new SqlField('bookingChangeProposal', 'venueAddress', '', 'id', 'bookingChangeProposal_venueAddress');
    this.primaryOfferingId = new SqlField('bookingChangeProposal', 'primaryOfferingId', '', 'id', 'bookingChangeProposal_primaryOffering');
    this.totalAmount = new SqlField('bookingChangeProposal', 'totalAmount', '', 'id', 'bookingChangeProposal_totalAmount');
    this.depositAmount = new SqlField('bookingChangeProposal', 'depositAmount', '', 'id', 'bookingChangeProposal_depositAmount');
    this.note = new SqlField('bookingChangeProposal', 'note', '', 'id', 'bookingChangeProposal_note');
    this.packagesJson = new SqlField('bookingChangeProposal', 'packagesJson', '', 'id', 'bookingChangeProposal_packagesJson');
    this.adjustmentsJson = new SqlField('bookingChangeProposal', 'adjustmentsJson', '', 'id', 'bookingChangeProposal_adjustmentsJson');
    this.status = new SqlField('bookingChangeProposal', 'status', '', 'id', 'bookingChangeProposal_status');
    this.decidedDate = new SqlField('bookingChangeProposal', 'decidedDate', '', 'id', 'bookingChangeProposal_decidedDate');
    this.depositPercent = new SqlField('bookingChangeProposal', 'depositPercent', '', 'id', 'bookingChangeProposal_depositPercent');
    this.booking = createNavHybrid('bookingChangeProposal', 'bookingChangeProposal_booking', 'Booking');
    this.createdByUser = createNavHybrid('bookingChangeProposal', 'bookingChangeProposal_createdByUser', 'User');
    this.eventSession = createNavHybrid('bookingChangeProposal', 'bookingChangeProposal_eventSession', 'EventSession');
    this.primaryOffering = createNavHybrid('bookingChangeProposal', 'bookingChangeProposal_primaryOffering', 'Offering');
    this.updatedByUser = createNavHybrid('bookingChangeProposal', 'bookingChangeProposal_updatedByUser', 'User');
    this.id = new SqlField('bookingChangeProposal', 'id', '', 'id', 'bookingChangeProposal_id');
    this.isDeleted = new SqlField('bookingChangeProposal', 'isDeleted', '', 'id', 'bookingChangeProposal_isDeleted');
    this.createdBy = new SqlField('bookingChangeProposal', 'createdBy', '', 'id', 'bookingChangeProposal_createdBy');
    this.createdDate = new SqlField('bookingChangeProposal', 'createdDate', '', 'id', 'bookingChangeProposal_createdDate');
    this.updatedBy = new SqlField('bookingChangeProposal', 'updatedBy', '', 'id', 'bookingChangeProposal_updatedBy');
    this.updatedDate = new SqlField('bookingChangeProposal', 'updatedDate', '', 'id', 'bookingChangeProposal_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:BookingChangeProposalSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:BookingChangeProposalSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:BookingChangeProposalSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:BookingChangeProposalSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:BookingChangeProposalSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:BookingChangeProposalSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:BookingChangeProposalSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:BookingChangeProposalSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:BookingChangeProposalSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:BookingChangeProposalSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
